// extracted by mini-css-extract-plugin
module.exports = {"button":"Button-module--button--3FnXy","bgPos":"Button-module--bgPos--3aBKJ","width":"Button-module--width--1Wzxe"};